import { IRoundBoardResponse, IRoundRightsResponse } from '../../data-models/round-governance.data-model';
import { MaggieHttp } from '../MaggieHttp';

/** Board of directors parsed from a round's deal documents. */
export async function getRoundBoard(roundId: number): Promise<IRoundBoardResponse> {
  const { data } = await MaggieHttp.maggie.get<IRoundBoardResponse>(`/round/${roundId}/board`);
  return data;
}

/** Investor rights and governance terms parsed from a round's deal documents. */
export async function getRoundRights(roundId: number): Promise<IRoundRightsResponse> {
  const { data } = await MaggieHttp.maggie.get<IRoundRightsResponse>(`/round/${roundId}/rights`);
  return data;
}
